"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _md = require("react-icons/md");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _system = _interopRequireDefault(require("../../../utils/system"));

var _IconButton = _interopRequireDefault(require("../../IconButton/IconButton"));

var _jsxRuntime = require("react/jsx-runtime");

var _variants, _iconMap;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  /**
   * Custom node to replace the default action.
   */
  action: _propTypes.node,

  /**
   * The content of the alert.
   */
  children: _propTypes.node.isRequired,

  /**
   * Custom node to replace the default icon mapping.
   */
  icon: _propTypes.node,

  /**
   * State of the alert.
   */
  isOpen: _propTypes.bool,

  /**
   * Callback to fire when the close button is clicked.
   */
  onClose: _propTypes.func,

  /**
   * Show or hide the icon.
   */
  showIcon: _propTypes.bool,

  /**
   * Variant of the alert.
   */
  status: (0, _propTypes.oneOf)(['error', 'info', 'success', 'warning'])
};
var defaultProps = {
  action: null,
  icon: null,
  isOpen: true,
  onClose: null,
  showIcon: false,
  status: 'success'
};
var variants = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning'
};
var Alert = (0, _system["default"])('div')({
  label: 'Alert'
}, (0, _css["default"])({
  borderRadius: 'md',
  boxSizing: 'border-box',
  color: 'white',
  display: 'flex',
  px: 4,
  py: 2,
  position: 'relative'
}), (0, _styledSystem.variant)({
  scale: 'alert',
  prop: 'status',
  variants: (_variants = {}, _defineProperty(_variants, variants.error, {
    bg: 'danger'
  }), _defineProperty(_variants, variants.info, {
    bg: 'info'
  }), _defineProperty(_variants, variants.success, {
    bg: 'success'
  }), _defineProperty(_variants, variants.warning, {
    bg: 'warning'
  }), _variants)
}));
var AlertContent = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "ec01epl2"
} : {
  target: "ec01epl2",
  label: "AlertContent"
})((0, _css["default"])({
  flexGrow: 1,
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'normal',
  lineHeight: 'base',
  py: '8px'
}));
var AlertIcon = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "ec01epl1"
} : {
  target: "ec01epl1",
  label: "AlertIcon"
})((0, _css["default"])({
  lineHeight: 0,
  mr: 4,
  py: '7px'
}));
var AlertAction = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "ec01epl0"
} : {
  target: "ec01epl0",
  label: "AlertAction"
})((0, _css["default"])({
  alignItems: 'center',
  display: 'flex',
  ml: 4
}));
var iconMap = (_iconMap = {}, _defineProperty(_iconMap, variants.error, /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdError, {
  size: 22
})), _defineProperty(_iconMap, variants.warning, /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdWarning, {
  size: 22
})), _defineProperty(_iconMap, variants.success, /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdCheckCircle, {
  size: 22
})), _defineProperty(_iconMap, variants.info, /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdInfo, {
  size: 22
})), _iconMap);
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var action = _ref.action,
      status = _ref.status,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      showIcon = _ref.showIcon,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["action", "status", "children", "isOpen", "onClose", "showIcon", "icon"]);

  return !isOpen ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(Alert, _objectSpread(_objectSpread({
    ref: ref,
    status: status
  }, props), {}, {
    children: [showIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertIcon, {
      children: icon || iconMap[status]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertContent, {
      children: children
    }), (action || onClose) && /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertAction, {
      children: action || /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        onClick: onClose,
        color: "inherit",
        classes: {
          root: {
            fontSize: '18px',
            height: '26px',
            minWidth: '26px'
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdClose, {})
      })
    })]
  }));
});
Component.displayName = 'Alert';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Alert.js.map